






import { computed, defineComponent, PropType } from "@vue/composition-api";
export default defineComponent({
  name: "LayoutHorizontal",
  props: {
    size: {
      type: String as PropType<"small" | "medium" | "large">,
      default: "medium",
      validator: (size: string) => {
        return ["small", "medium", "large"].includes(size);
      }
    },
    align: {
      type: String as PropType<"start" | "center" | "end">,
      default: "center",
      validator: (size: string) => {
        return ["start", "center", "end"].includes(size);
      }
    }
  },
  setup(props) {
    const classes = computed(() => {
      return [
        `layout-horizontal__size--${props.size}`,
        `layout-horizontal__align--${props.align}`
      ];
    });
    return { classes };
  }
});
